<template>
  <section class="contest-step1">
    <p>{{$t('global.注')}}：{{$t('global.以下信息仅用于竞赛，我们将严格保密（个人介绍和所在地除外）')}}</p>
    <el-form :model="form" :rules="rules" ref="userForm">
      <el-form-item :label="$t('global.真实姓名')" :label-width="formLabelWidth" prop="name" v-if="matchId !== 1027">
        <el-input v-model="form.name" auto-complete="off" :placeholder="$t('global.请输入真实姓名')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('global.手机号')" :label-width="formLabelWidth" prop="phone">
        <router-link
          :to="`/manageCenter?step=1&redirecturl=${redirecturl}`"
          v-if="!peopleMessage.phone"
        >{{$t('global.去绑定')}}</router-link>
        <p v-if="peopleMessage.phone" class="hasPhone">
          <span>{{peopleMessage.phone}}</span>
          {{$t('global.如需更换请前往')}}
          <router-link :to="`/manageCenter?step=1&redirecturl=${redirecturl}`">{{$t('global.个人中心')}}</router-link>
        </p>
      </el-form-item>
      <el-form-item :label="$t('global.邮箱')" :label-width="formLabelWidth" prop="email">
        <p v-if="peopleMessage.email" class="hasPhone">
          <span>{{peopleMessage.email}}</span>
          {{$t('global.如需更换请前往')}}
          <router-link :to="`/manageCenter?step=1&redirecturl=${redirecturl}`">{{$t('global.个人中心')}}</router-link>
        </p>
        <router-link
          :to="`/manageCenter?step=1&redirecturl=${redirecturl}`"
          v-if="!peopleMessage.email"
        >{{$t('global.去绑定')}}</router-link>
      </el-form-item>
      <el-form-item :label="$t('global.微信号')" :label-width="formLabelWidth" prop="wechatLink">
      <el-input v-model="form.wechatLink" auto-complete="off" :placeholder="$t('works.如没有微信请输入无')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('global.国籍')" :label-width="formLabelWidth" prop="nationality">
        <el-select v-model="form.nationality" filterable :placeholder="$t('video.请搜索或选择国籍')">
          <el-option :label="language === 'zh'?item.zh:item.en" :value="language === 'zh'?item.zh:item.en" v-for="(item,i) in countryOptions" :key="i"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('global.个人/团队介绍')" :label-width="formLabelWidth" prop="introduce">
        <el-input
          v-model="form.introduce"
          type="textarea"
          auto-complete="off"
          :placeholder="matchId == 1031 ? $t('video.请输入个人简介及获奖经历') : $t('global.请输入个人/团队简介')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="`${$t('global.个人/团队介绍')}(${$t('global.英文')})`"
        :label-width="formLabelWidth"
        prop="enIntroduce"
        v-if="matchProperty==1 && language==='zh'"
      >
        <el-input
          v-model="form.enIntroduce"
          type="textarea"
          auto-complete="off"
          :placeholder="matchId == 1031 ? `${$t('video.请输入个人简介及获奖经历')}(${$t('global.英文')})` : `${$t('global.请输入个人简介')}(${$t('global.英文')})`"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('global.所在地')" :label-width="formLabelWidth" prop="country">
        <el-select
          v-model="form.country"
          @change="resetArea"
          filterable
          :placeholder="$t('project.请搜索或选择国家')"
        >
          <el-option
            :label="language === 'zh'?item.zh:item.en"
            :value="item.id"
            v-for="(item,i) in countryOptions"
            :key="i"
          ></el-option>
        </el-select>
        <el-select v-model="form.area" filterable :placeholder="$t('global.请选择城市')">
          <el-option :label="language === 'zh'?item.zh:item.en" :value="item.id" v-for="(item,i) in cityOptions" :key="i"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('global.状态')" :label-width="formLabelWidth" prop="isGraduation" v-if="matchShow == 1">
        <el-select v-model="form.isGraduation" prop="isGraduation">
          <el-option :label="$t('global.已毕业')" :value="1"></el-option>
          <el-option :label="$t('global.在读学生')" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('global.毕业/所在院校')" :label-width="formLabelWidth" v-if="matchShow == 1">
        <el-input
          class="inline-block"
          v-model="form.school"
          auto-complete="off"
          :placeholder="$t('global.请输入毕业/所在院校')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('global.职业')" :label-width="formLabelWidth" prop="career" v-if="matchId !== 1027">
        <el-input v-model="form.career" auto-complete="off" :placeholder="$t('global.请输入职业')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('works.当前学习阶段')" :label-width="formLabelWidth" prop="leartPhase" v-if="form.isGraduation == 2 && matchId == 1027">
        <el-select v-model="form.leartPhase" prop="leartPhase">
          <el-option :label="$t('works.专科')" :value="'1'"></el-option>
          <el-option :label="$t('works.本科')" :value="'2'"></el-option>
          <el-option :label="$t('works.研究生')" :value="'3'"></el-option>
          <el-option :label="$t('global.其他')" :value="'4'"></el-option>
        </el-select>
      </el-form-item>
      <div v-if="matchId == 1027">
        <el-form-item :label="$t('works.学号')" :label-width="formLabelWidth">
          <el-input v-model="form.snumber" auto-complete="off" :placeholder="$t('works.请输入学号')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('works.通讯地址')" :label-width="formLabelWidth" prop="address">
          <el-input v-model="form.address" auto-complete="off" :placeholder="$t('works.请输入通讯地址')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.微信号')" :label-width="formLabelWidth" prop="wechatLink">
          <el-input v-model="form.wechatLink" auto-complete="off" :placeholder="$t('works.请输入微信号')"></el-input>
        </el-form-item>
      </div>
      <!-- <el-form-item :label="$t('global.职位')" :label-width="formLabelWidth" prop="jobTitle">
        <el-input v-model="form.jobTitle" auto-complete="off" :placeholder="$t('global.请输入职位')"></el-input>
      </el-form-item> -->
      <div v-if="matchId == 1067">
        <!-- <div> -->
        <el-form-item label="您是如何了解到此次活动" :label-width="formLabelWidth">
          <el-select v-model="form.about" filterable placeholder="途径">
            <el-option
              v-for="item in abouts"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
        </el-select>
        </el-form-item>
      </div>
    </el-form>
  </section>
</template>

<script>
export default {
  data() {
    return {
      abouts: [{
          value: '小红书',
          label: '小红书'
        }, {
          value: '微信公众号',
          label: '微信公众号'
        }, {
          value: 'AINext社群',
          label: 'AINext社群'
        }, {
          value: 'MANA全球新媒体艺术平台',
          label: 'MANA全球新媒体艺术平台'
        }, {
          value: '老师推荐',
          label: '老师推荐'
        },
        {
          value: '朋友推荐',
          label: '朋友推荐'
        },
        {
          value: '其他',
          label: '其他'
        }],

      form: {
        name: "",
        phone: "",
        email: "",
        nationality: "",
        introduce: "",
        enIntroduce: "",
        country: "",
        area: "",
        isGraduation: '',
        school: "",
        career: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("global.请输入真实姓名"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: this.$t("global.请先绑定手机号")
          }
        ],
        email: [
          {
            required: true,
            message: this.$t("global.请先绑定邮箱")
          }
        ],
        nationality: [
          {
            required: true,
            message: this.$t("global.请选择国籍"),
            trigger: "blur"
          }
        ],
        country: [
          {
            required: true,
            message: this.$t("global.请选择所在地"),
            trigger: "blur"
          }
        ],
        isGraduation: [
          {
            required: true,
            message: this.$t("live.请选择状态"),
            trigger: "blur"
          }
        ],
        school: [
          {
            required: true,
            message: this.$t('global.请输入毕业/所在院校'),
            trigger: "blur"
          }
        ],
        leartPhase: [
          {
            required: true,
            message: this.$t('works.请选择当前学习阶段'),
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('works.请输入通讯地址'),
            trigger: "blur"
          }
        ],
        wechatLink: [
          {
            required: true,
            message: this.$t('works.如没有微信请输入无'),
            trigger: "blur"
          }
        ],
        // jobTitle: [
        //   {
        //     required: true,
        //     message: this.$t("global.请输入职位"),
        //     trigger: "blur"
        //   }
        // ],
        introduce: [
          {
            required: true,
            message: this.$t("global.请输入个人/团队简介"),
            trigger: "blur"
          },
          {
            max: 2000,
            message: this.$t("global.最多输入2000个字符"),
            trigger: "blur"
          }
        ],
        enIntroduce: [
          {
            required: true,
            message: this.$t("global.请输入个人/团队简介"),
            trigger: "blur"
          },
          {
            max: 2000,
            message: this.$t("global.最多输入2000个字符"),
            trigger: "blur"
          }
        ]
      },
      formLabelWidth: "180px",
      nationalityOptions: [],
      countryOptions: [],
      cityOptions: []
    };
  },
  props: ["matchProperty", "callback", "matchId", "peopleMessage","matchShow"],
  mounted() {
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    },
    redirecturl() {
      return window.location.href.split("?")[0];
    },
  },
  watch: {
    "form.country"(value) {
      if (value || value === 0) {
        this.getCity(value);
      }
    },
    peopleMessage() {
      this.form = {
        name: this.peopleMessage.name,
        phone: this.peopleMessage.phone,
        email: this.peopleMessage.email,
        nationality: this.peopleMessage.nationality,
        introduce: this.peopleMessage.introduce,
        enIntroduce: this.peopleMessage.enIntroduce,
        country: +this.peopleMessage.country,
        area: +this.peopleMessage.area,
        isGraduation: this.peopleMessage.isGraduation,
        school: this.peopleMessage.school,
        career: this.peopleMessage.career,
        wechatLink: this.peopleMessage.wechatLink,
        snumber: this.peopleMessage.snumber,
        address: this.peopleMessage.address,
        leartPhase: this.peopleMessage.leartPhase,
        jobTitle: this.peopleMessage.jobTitle,
        about: this.peopleMessage.about
      };
    }
  },
  methods: {
    resetArea() {
      this.form.area = "";
    },
    init() {
      this.form = {
        name: this.peopleMessage.name,
        phone: this.peopleMessage.phone,
        email: this.peopleMessage.email,
        nationality: this.peopleMessage.nationality,
        introduce: this.peopleMessage.introduce,
        enIntroduce: this.peopleMessage.enIntroduce,
        country: +this.peopleMessage.country,
        area: +this.peopleMessage.area,
        isGraduation: this.peopleMessage.isGraduation,
        school: this.peopleMessage.school,
        career: this.peopleMessage.career,
        wechatLink: this.peopleMessage.wechatLink,
        snumber: this.peopleMessage.snumber,
        address: this.peopleMessage.address,
        leartPhase: this.peopleMessage.leartPhase,
        jobTitle: this.peopleMessage.jobTitle,
        about: this.peopleMessage.about
      };
      this.getCountry();
      this.getNationality();
    },
    getNationality() {
      this.$http.get("/api/common/country/list").then(res => {
        if (res.code === "OK") {
          this.nationalityOptions = res.data;
        }
      });
    },
    getCountry() {
      this.$http.get("/api/mobile/area/getCountry").then(res => {
        if (res.code === "OK") {
          const data = res.data;
          Object.keys(data).map(item => {
            this.countryOptions = [...this.countryOptions, ...data[item]];
          });
          if (this.language === 'zh') {
            this.countryOptions.unshift({
              'city': [],
              'en': "China",
              'id': 0,
              'py': "People's Republic of China",
              'pyf': "P",
              'value': "",
              'zh': "中国"
            })
          }
        }
      });
    },
    getCity(id) {
      this.$http
        .get(`/api/mobile/area/getCityByCountryId?countryId=${id}`)
        .then(res => {
          if (res.code === "OK") {
            this.cityOptions = res.data;
          }
        });
    },
    submit() {
      if (!this.form.name.replace(/[\r\n\s]/g,"")&&this.matchId !== 1027) {
        this.$message.error(this.$t('global.请输入真实姓名'))
        return
      }
      if (!this.form.phone) {
        this.$message.error(this.$t('global.请先绑定手机号'))
        return
      }
      if (!this.form.email) {
        this.$message.error(this.$t('global.请先绑定邮箱'))
        return
      }
      if (!this.form.nationality) {
        this.$message.error(this.$t('global.请选择国籍'))
        return
      }
      if (!this.form.introduce.replace(/[\r\n\s]/g,"")) {
        this.$message.error(this.$t('global.请输入个人简介'))
        return
      }
      if (!this.form.enIntroduce.replace(/[\r\n\s]/g,"")&&this.matchProperty==1&&this.language === 'zh') {
        this.$message.error(this.$t('global.请输入个人简介'))
        return
      }
      if (this.form.country == "null" && this.form.country !== "0") {
        this.$message.error(this.$t('global.请选择所在地'))
        return
      }
      if (this.matchShow == 1 && !this.form.isGraduation) {
        this.$message.error(this.$t('live.请选择状态'))
        return
      }
      // if (this.matchShow == 1 && !this.form.school) {
      //   this.$message.error(this.$t('global.请输入毕业/所在院校'))
      //   return
      // }
      this.$refs.userForm.validate(valid => {
        if (valid) {
          const { phone, email, ...rest } = this.form;
          const url = `/api/match/user/createSuccessMatchUser`;
          if (this.matchId == 1031) {
            sessionStorage.setItem("changeUserInfo", JSON.stringify(this.form));
          }
          this.$http.post(url, { ...rest, matchId: this.matchId, about: this.form.about }).then(res => {
            if (res.code === "OK") {
              const peopleMessage = {
                ...this.peopleMessage,
                ...this.form
              };
              this.$store.dispatch("setNewState", {
                peopleMessage: peopleMessage,
                accountUser: peopleMessage
              });
              this.$emit("callback", true);
              //点击下一步回到上面
              this.$nextTick(()=>{
                document.getElementById("nav").scrollIntoView(true);
              })
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="stylus">
.el-select .el-input__inner{
  cursor: auto;
}
</style>
<style lang="stylus" scoped>
.contest-step1 {
  padding: 0 80px;
  font-size: 14px;

  .hasPhone {
    line-height: 40px;
    height: auto;
  }

  p {
    height: 20px;
    // font-size: 14px;
    color: #999;
    line-height: 20px;
  }

  .el-form {
    padding-top: 20px;

    .el-form-item {
      color: #999;

      .el-form-item__label {
        color: #999;
      }
    }

    .el-input {
      width: 320px;
    }

    .el-select {
      width: 160px;
    }
  }
}
</style>

<style lang="stylus">
.contest-step1 {
  .el-form {
    padding-top: 20px;

    .el-form-item {
      color: #999;

      .el-form-item__label {
        color: #999;
      }

      .el-form-item__content {
        input, select {
          height: 32px;
        }

        .el-textarea {
          // height:100px;
          textarea {
            height: 120px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/match/contestEnterStep/step1.vue